import styled from "styled-components";

export const PageTitle = styled.h2`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  min-height: ${({ theme }) => theme.font_size.x_large }px;
  font-size: ${({ theme }) => theme.font_size.x_large }px;
  line-height: ${({ theme }) => theme.typography.lineHeight.compact };
  font-weight: ${({ theme }) => theme.typography.weight.bold };
  letter-spacing: ${({ theme }) => theme.typography.letterSpacing.tight };

  color: ${({ theme }) => theme.colors.text.default };
`;
